import React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import ClipLoader from 'react-spinners/ClipLoader';

interface IStepNumberProps {
    name: MessageDescriptor;
    touched: boolean;
    index: number;
    isLoading?: boolean;
}

const StepNumber: React.FunctionComponent<IStepNumberProps> = ({ touched, name, index, isLoading }) => {
    const stepTouchedClass = touched ? 'step-number--touched' : '';
    return (
        <header className={`step-number ${stepTouchedClass}`} id={`step-${index - 1}`}>
            <div className="step-number__circle">
                {isLoading
                    ? <ClipLoader size="1em" color="white" />
                    : <span>{index}</span>
                }
            </div>
            <h2 className="step-number__title">
                <FormattedMessage {...name} />
            </h2>
        </header>
    );
};

export default StepNumber;
